import React from "react";

import _ from "lodash";

import { toast } from "react-toastify";
import { push } from "connected-react-router";
import { Parser } from "expr-eval-fork";

import { constructQueryParams } from "api/BaseAPI";
import * as BlueprintAPI from "api/BlueprintAPI";
import * as MarketplaceDemoAPI from "api/MarketplaceDemoAPI";
import * as DatasetAPI from "api/DatasetAPI";

import {
  getIsBusinessMode,
  getIsDataMode,
  getActiveBlueprintId,
  updateIsBlueprintCreating,
  updateIsBlueprintsLoading,
  updateActiveBlueprintId
} from "containers/App/reducer";

import * as globalReducer from "containers/App/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as aibleAnywhereReducer from "containers/AibleAnywhere/reducer";
import * as templateReducer from "containers/Templates/reducer";
import * as viewReducer from "containers/View/reducer";
import * as accountsReducer from "containers/Accounts/reducer";

import SAMPLE_BLUEPRINTS from "@/containers/Blueprint/SampleBlueprints";

import {
  defaultSetup,
  getDatasetFromSetup,
  getSetup,
  getOutcomeType,
  resetSetup,
  updateIsBlueprint,
  updateDatasetId,
  updateBlueprintId,
  updateSetup,
  updateSuccess
} from "containers/Setup/reducer";
import * as setupReducer from "containers/Setup/reducer";
import {
  getDataset,
  getDatasetId,
  updateDataset,
  updateDatasets,
  transformUpdateDataset,
  fetchDataset
} from "containers/Home/reducer";
import { getSelectedTenant, getUserID } from "containers/Login/reducer";
import { updateStep, getStep } from "containers/CreateWizard/reducer";

import * as runReducer from "containers/Run/reducer";
import * as wizardReducer from "containers/Wizard/reducer";

import * as transformReducer from "containers/Dataset/reducer";
import * as marketplaceDemoReducer from "containers/MarketplaceDemo/reducer";
import { getIsMarketplaceDemo } from "containers/MarketplaceDemo/reducer";

import * as loginReducer from "containers/Login/reducer";
import * as marketplaceReducer from "containers/Marketplace/reducer";
import * as projectReducer from "containers/Project/reducer";
import { getIsMarketplace } from "containers/Marketplace/reducer";
import * as nextReducer from "containers/Next/NextReducer";

import { sanitizeAliasForBQ } from "utils/relation";

import { INITIAL_BLUEPRINTS, MODEL_TYPES, ORIGINAL_STEPS, STEP_TYPE } from "containers/Wizard/reducer";

const PREBUILT_BLUEPRINTS = ["academic", "template", "business"];

import { getCreateFromProject, getSetupLabel } from "containers/Setup/reducer";

import { isEnabled } from "utils/featureFlags";
import * as homeReducer from "containers/Home/reducer";
import * as languageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";
import {
  CHATAIBLE_BLUEPRINTS,
  checkIsValidChatBlueprint,
  CHATAIBLE_KPI_ANALYSIS,
  CHATAIBLE_DOCUMENT_SUMMARIZATION,
  CHATAIBLE_SQL,
  CHATAIBLE_WHATS_CHANGED,
  CHATAIBLE_BENCHMARK,
  CHATAIBLE_REASON,
  CHATAIBLE_REASON_NLQ,
  CHATAIBLE_AGENT_IQ,
  CHATAIBLE_AGENT_IQ_STREAM,
  CHATAIBLE_AGENT_IQ_TEAM,
  CHATAIBLE_DOCUMENT_SUMMARIZATION_SIMPLE,
  CHATAIBLE_OPTIMIZE,
  CHATAIBLE_PREDICT,
  CHATAIBLE_AGENT_C,
  ANALYTICS_USECASE_TEMPLATES,
  NLQ_USECASE_TEMPLATES,
  DOCSUM_USECASE_TEMPLATES,
  WHATS_CHANGED_USECASE_TEMPLATES,
  BENCHMARK_SAMPLE_TEMPLATES,
  AIBLE_OPTIMIZE_TEMPLATES,
  AIQ_DEEP_RESEARCH,
  OPENSHELL,
  CLAUDE_CODE
} from "containers/ChatGPT/reducer";
import { aible } from "components/CreateWizard/style.module.css";
import { USECASE_TEMPLATES } from "containers/ChatGPT/reducer";
import { TEMPLATES_SAMPLE_DATA } from "containers/ChatGPT/ChatTemplateSampleData";

const UPDATE_BLUEPRINTS = "blueprint/UPDATE_BLUEPRINTS";
const RESET_BLUEPRINTS = "blueprint/RESET_BLUEPRINTS";
const UPDATE_BLUEPRINT = "blueprint/UPDATE_BLUEPRINT";
const UPDATE_FIELD = "blueprint/UPDATE_FIELD";
const UPDATE_SENSITIVE = "blueprint/UPDATE_SENSITIVE";
const UPDATE_BLUEPRINT_FIELD = "blueprint/UPDATE_BLUEPRINT_FIELD";
const DELETE_BLUEPRINT_FIELD = "blueprint/DELETE_BLUEPRINT_FIELD";
const UPDATE_CUSTOM_FIELD = "blueprint/UPDATE_CUSTOM_FIELD";
const DELETE_CUSTOM_FIELD = "blueprint/DELETE_CUSTOM_FIELD";
const UPDATE_ADVANCED_INPUT = "blueprint/UPDATE_ADVANCED_INPUT";

let initialState = {};

const oldSteps = Object.keys(INITIAL_BLUEPRINTS).map((s, i) => ({
  name: s.replace("_", " ").toLowerCase(),
  wizard: {
    setup: {
      success: s.indexOf("CATEGORICAL") !== -1 ? { label: undefined, value: undefined } : undefined,
      mode: s.indexOf("ACADEMIC") !== -1 ? 0 : s.indexOf("QUICK") !== -1 ? 1 : 2
    },
    dataset: { fields: {} },
    steps: [...INITIAL_BLUEPRINTS[s].steps],
    [MODEL_TYPES.REGRESSION]: [...INITIAL_BLUEPRINTS[s][MODEL_TYPES.REGRESSION]],
    [MODEL_TYPES.CLASSIFICATION]: [...INITIAL_BLUEPRINTS[s][MODEL_TYPES.CLASSIFICATION]]
  },
  tenant_id: 1,
  id: s,
  oldType: s,
  isAible: true
}));

for (const step of oldSteps) {
  initialState[step.oldType] = { ...step };
}

Object.values(CHATAIBLE_BLUEPRINTS)
  .reverse()
  .forEach((bp) => {
    initialState[bp.id] = { ...bp };
  });

export const cDel = "@_@COL@_@";

//Accepted characters for naming custom fields
export const CUSTOM_FIELD_VALID_CHARS = /^[a-z0-9_\xC0-\xFF$€£¥元]+$/i;

function blueprintReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case UPDATE_BLUEPRINTS:
      return {
        ...action.data
      };
    case RESET_BLUEPRINTS:
      return {
        ...initialState
      };
    case UPDATE_BLUEPRINT:
      return {
        ...state,
        [action.id]: action.data
      };
    case UPDATE_BLUEPRINT_FIELD:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          [action.key]: action.data
        }
      };
    case UPDATE_BLUEPRINT_FIELD:
      const blueprint = { ...state[action.id] };
      delete blueprint[action.key];
      return {
        ...state,
        [action.id]: blueprint
      };
    case UPDATE_FIELD:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["wizard"]: {
            ...(state[action.id] || {})["wizard"],
            [action.key]: action.data
          }
        }
      };
    case UPDATE_CUSTOM_FIELD:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["wizard"]: {
            ...(state[action.id] || {})["wizard"],
            ["customFields"]: {
              ...((state[action.id] || {})["wizard"] || {})["customFields"],
              [action.key]: action.data
            }
          }
        }
      };
    case DELETE_CUSTOM_FIELD:
      const cFields = { ...state[action.id]["wizard"]["customFields"] };
      delete cFields[action.key];
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["wizard"]: {
            ...state[action.id]["wizard"],
            ["customFields"]: cFields
          }
        }
      };
    case UPDATE_SENSITIVE:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["wizard"]: {
            ...state[action.id]["wizard"],
            ["sensitive"]: {
              ...state[action.id]["wizard"]["sensitive"],
              [action.key]: action.data
            }
          }
        }
      };
    case UPDATE_ADVANCED_INPUT:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["wizard"]: {
            ...(state[action.id] || {})["wizard"],
            ["advancedInputs"]: {
              ...((state[action.id] || {})["wizard"] || {})["advancedInputs"],
              [action.key]: action.data
            }
          }
        }
      };
    default:
      return state;
  }
}

/* Selectors */
export function getGlobal(state) {
  return state.blueprint;
}

export function getBlueprint(state, id) {
  if (id === undefined) {
    return undefined;
  }

  return state.blueprint[id];
}

export function constructFieldsFromDatasetBlueprint(state, id) {
  const blueprint = { ...getBlueprint(state, id) };

  let retFields =
    blueprint && blueprint.wizard && blueprint.wizard.blueprintFields
      ? blueprint.wizard.blueprintFields
      : blueprint && blueprint.wizard && blueprint.wizard.dataset && blueprint.wizard.dataset.fields
        ? {
            ...Object.keys(blueprint.wizard.dataset.fields).map((f) => ({
              isSensitive: blueprint.wizard.sensitive ? blueprint.wizard.sensitive[f] === true : false,
              ...blueprint.wizard.dataset.fields[f]
            }))
          }
        : {};

  return retFields;
}

export function getBlueprintFields(state, id) {
  const blueprint = { ...getBlueprint(state, id) };

  if (blueprint === undefined) {
    return undefined;
  }

  return blueprint && blueprint.wizard && blueprint.wizard.blueprintFields
    ? {
        ...blueprint.wizard.blueprintFields,
        ...constructFieldsFromDatasetBlueprint(state, id)
      }
    : { ...constructFieldsFromDatasetBlueprint(state, id) };
}

export function getPermissions(state, id) {
  const blueprint = getBlueprint(state, id);
  return blueprint && blueprint.permissions;
}

export function getUserDeletePermission(state, id) {
  const permissions = getPermissions(state, id);
  return permissions && permissions.can_delete;
}

export function getUserEditPermission(state, id) {
  const permissions = getPermissions(state, id);
  return permissions && permissions.can_edit;
}

export function getUserManagePermissions(state, id) {
  const permissions = getPermissions(state, id);
  return permissions && permissions.can_manage_permissions;
}

export function getDescription(state, id, bId) {
  const blueprint = getBlueprint(state, id);

  return blueprint ? (blueprint.wizard ? blueprint.wizard[bId] : blueprint[bId]) : undefined;
}

export function getColumnDescription(state, id, column) {
  const blueprint = getBlueprint(state, id);

  return blueprint && blueprint.wizard && blueprint.wizard[cDel + column] ? blueprint.wizard[cDel + column] : undefined;
}

export function getCustomFields(state, id) {
  const blueprint = getBlueprint(state, id);

  return blueprint && blueprint.wizard ? blueprint.wizard.customFields : {};
}

export function getIsSensitive(state, id) {
  const blueprint = getBlueprint(state, id);

  return blueprint && blueprint.wizard ? blueprint.wizard.sensitive : {};
}

export function getCustomFieldsTransformed(state, id) {
  const advancedInputs = getAdvancedInputs(state, id) || {};

  const customFields = getCustomFields(state, id);

  return customFields
    ? Object.keys(customFields)
        .filter((c) => customFields[c] !== undefined)
        .map((c) => ({
          ...customFields[c],
          isBenefit:
            (advancedInputs["truePositive"] && advancedInputs["truePositive"].indexOf(c) !== -1) ||
            (advancedInputs["trueNegative"] && advancedInputs["trueNegative"].indexOf(c) !== -1),
          isCost:
            (advancedInputs["falsePositive"] && advancedInputs["falsePositive"].indexOf(c) !== -1) ||
            (advancedInputs["falseNegative"] && advancedInputs["falseNegative"].indexOf(c) !== -1)
        }))
    : [];
}

export function getIsAdvanced(state, id) {
  const blueprint = getBlueprint(state, id);

  return blueprint && blueprint.wizard ? blueprint.wizard.isAdvanced : undefined;
}

export function getIsLocked(state, id) {
  const blueprint = getBlueprint(state, id);

  return blueprint && blueprint.wizard ? blueprint.wizard.isLocked : undefined;
}

export function getAppStartViewType(state, id) {
  const blueprint = getBlueprint(state, id);

  return blueprint && blueprint.wizard ? blueprint.wizard.appStartViewType : "DASHBOARD";
}

export function getAdvancedInputs(state, id) {
  const blueprint = getBlueprint(state, id);

  return blueprint && blueprint.wizard ? blueprint.wizard.advancedInputs : {};
}

export function getAllColumnDescription(state, id) {
  const blueprint = getBlueprint(state, id);

  let retObj = {};

  if (blueprint && blueprint.wizard && blueprint.wizard.dataset) {
    const dataset = blueprint.wizard.dataset;

    Object.keys(dataset.fields).forEach(
      (f) =>
        (retObj[f] = getColumnDescription(state, id, f) ? getColumnDescription(state, id, f) : dataset.fields[f].desc)
    );
  } else {
    const dataset =
      id === "new"
        ? getDatasetFromSetup(state, id)
        : blueprint && blueprint.wizard && blueprint.wizard.setup
          ? getDataset(state, blueprint.wizard.setup.datasetId)
          : undefined;

    dataset &&
      dataset.fields &&
      Object.keys(dataset.fields).forEach((f) => (retObj[f] = getColumnDescription(state, id, f)));
  }

  return retObj;
}

export function getBlueprints(state) {
  return Object.keys(getGlobal(state)).map((b) => getGlobal(state)[b]);
}

export function getSortedBlueprints(state, onlyChatBlueprints = false) {
  const selectedTenant = getSelectedTenant(state);

  return (
    Object.keys(getGlobal(state))
      .map((b) => {
        if (b === "tempDefault") {
          return false;
        }
        return getGlobal(state)[b];
      })
      .filter((b) => {
        if (!b) {
          return false;
        }
        if (onlyChatBlueprints) {
          if (!b?.wizard?.chatGPT) {
            return false;
          }
          return checkIsValidChatBlueprint(b);
        }
        if (b?.wizard?.setup || b?.wizard?.nextObj) {
          return true;
        }
        // if (isEnabled("chat-aible")) {
        //   return checkIsValidChatBlueprint(b);
        // }
        return false;
      })
      // .filter(
      //   (b) =>
      //     b &&
      //     ((selectedTenant && b.tenant_id === selectedTenant.id) || b.oldType)
      // )
      .reverse()
  );
}

export function getOriginalSetup(state, id) {
  const blueprint = getBlueprint(state, id);
  return blueprint && blueprint.wizard ? blueprint.wizard.setup : undefined;
}

export function getOriginalDatasetId(state, id) {
  const blueprint = getBlueprint(state, id);

  return blueprint && blueprint.wizard && blueprint.wizard.setup ? blueprint.wizard.setup.datasetId : undefined;
}

export function getOriginalDataset(state, id) {
  const blueprint = getBlueprint(state, id);

  const retDataset = blueprint && blueprint.wizard && blueprint.wizard.dataset ? blueprint.wizard.dataset : undefined;

  if (retDataset && retDataset.id !== undefined && getDataset(state, retDataset.id) !== undefined) {
    return getDataset(state, retDataset.id);
  }

  return blueprint && blueprint.wizard && blueprint.wizard.dataset ? blueprint.wizard.dataset : undefined;
}

export function getExistsBlueprint(state, id) {
  return (dispatch, getState) => {
    const blueprint = getBlueprint(getState(), id);

    if (blueprint === undefined) {
      dispatch(
        updateBlueprint(id, {
          id: id,
          wizard: {}
        })
      );
    }

    return blueprint;
  };
}

export function getHasDataRecipe(state, id) {
  return getDataRecipe(state, id) !== undefined;
}

export function getDataRecipe(state, id) {
  const blueprint = getBlueprint(state, id) || {};

  return (blueprint.wizard || {}).recipe;
}

export function getDeployRecipe(state, id) {
  const recipe = getDataRecipe(state, id) || {};

  return recipe.deploy;
}

export function getImportRecipeId(state, id) {
  const blueprint = getBlueprint(state, id) || {};

  return (blueprint.wizard || {}).importRecipeId;
}

export function getDeployRecipeId(state, id) {
  const blueprint = getBlueprint(state, id) || {};

  return (blueprint.wizard || {}).deployRecipeId;
}

export function getIsEditing(state, id, runId) {
  return (id === "new" && runId === "new") || true
    ? true
    : getBlueprint(state, id)
      ? getBlueprint(state, id).isEditing
      : undefined;
}

export function getIsCreateNewBlueprint(state, runId, blueprintId) {
  return (
    runId !== "new" &&
    (blueprintId === undefined || getIsAibleBlueprint(state, blueprintId) || blueprintId === "template")
  );
}

export function getLinkedDatasets(state, id) {
  const blueprint = getBlueprint(state, id) || {};
  return (blueprint.wizard || {}).linkedDatasets;
}

export function getLinkedDatasetsArr(state, id) {
  const linkedDatasets = getLinkedDatasets(state, id);
  return linkedDatasets
    ? Object.keys(linkedDatasets)
        .filter((l) => linkedDatasets[l])
        .map((l) => homeReducer.getDataset(state, l))
    : [];
}

export function getIsAibleBlueprint(state, id) {
  return getBlueprint(state, id) ? getBlueprint(state, id).isAible : undefined;
}

export function getCanLockBlueprint(state, id) {
  const blueprint = getBlueprint(state, id) || {};

  const userId = getUserID(state);

  return (
    blueprint &&
    blueprint.created_by &&
    blueprint.created_by.id !== undefined &&
    userId !== undefined &&
    blueprint.created_by.id === userId
  );
}

export function getSteps(state, id, blueprintId) {
  const blueprint = getBlueprint(state, blueprintId);
  const options = getOptions(state, blueprintId);
  const isEditing = getIsEditing(state, blueprintId);

  if (blueprint && blueprint.isAible && blueprint.wizard && blueprint.wizard.steps) {
    const outcomeType = setupReducer.getOutcomeType(state, id);

    return outcomeType === "number" && blueprint.wizard.steps.length === 1
      ? blueprint.wizard[MODEL_TYPES.REGRESSION]
      : outcomeType === "categorical" && blueprint.wizard.steps.length === 1
        ? blueprint.wizard[MODEL_TYPES.CLASSIFICATION]
        : blueprint.wizard.steps;
  }

  let retSteps =
    blueprint && blueprint.wizard && blueprint.wizard.steps
      ? blueprint.wizard.steps.filter(
          (s) => !(options[s] && options[s]["hide"] === true) || blueprintId === "new" || isEditing
        )
      : blueprintId === "new" && id === "new"
        ? []
        : id !== "new"
          ? getStepFromType(state, id, blueprintId)
          : getStepFromBlueprintType(state, blueprintId, id);

  if (getIsDataMode(state)) {
    retSteps = getPrebuiltSteps("data", setupReducer.getOutcomeType(state, id));
  }

  return retSteps;
}

export function getOptions(state, blueprintId) {
  const blueprint = getBlueprint(state, blueprintId);

  return blueprint && blueprint.wizard && blueprint.wizard.options ? blueprint.wizard.options : {};
}

export function getOptionsByType(state, blueprintId, type) {
  const options = getOptions(state, blueprintId)[type];

  return options;
}

export function getIsLoadingBlueprint(state, blueprintId) {
  const blueprint = getBlueprint(state, blueprintId);

  return blueprint === undefined;
}

export function getIsAdvancedCosts(state, id) {
  const customFields = getCustomFields(state, id);

  return customFields && Object.keys(customFields).length > 0;
}

function getPrebuiltSteps(blueprintId, dataType) {
  switch (blueprintId) {
    case "academic":
      return ORIGINAL_STEPS.ACADEMIC;
    case "data":
      return ORIGINAL_STEPS.DATA_MODE;
  }
}

export function getStepFromBlueprintType(state, id, runId) {
  const blueprint = getBlueprint(state, id);

  if (id === "academic") {
    const dataset = setupReducer.getDatasetFromSetup(state, runId);
    return getPrebuiltSteps(
      id,
      dataset &&
        dataset.fields &&
        dataset.outcome &&
        dataset.fields[dataset.outcome] &&
        dataset.fields[dataset.outcome].type
    );
  }

  const isContinuous =
    blueprint && blueprint.wizard && blueprint.wizard.setup && blueprint.wizard.setup.success ? true : false;

  let mode = 0;
  if (blueprint) {
    if (blueprint.setup && blueprint.setup.mode !== undefined) {
      mode = blueprint.setup.mode;
    } else if (blueprint.wizard && blueprint.wizard.setup && blueprint.wizard.setup.mode !== undefined) {
      mode = blueprint.wizard.setup.mode;
    }
  }

  const isAdvanced = getIsAdvancedCosts(state, id);

  if (isAdvanced) {
    return isContinuous ? ORIGINAL_STEPS.ADVANCED_CONTINUOUS : ORIGINAL_STEPS.ADVANCED_CATEGORICAL;
  } else if (mode === 2) {
    return isContinuous ? ORIGINAL_STEPS.AIBLE_CONTINUOUS : ORIGINAL_STEPS.AIBLE_CATEGORICAL;
  } else if (mode === 1) {
    return isContinuous ? ORIGINAL_STEPS.QUICK_CONTINUOUS : ORIGINAL_STEPS.QUICK_CATEGORICAL;
  } else if (mode === 0) {
    return ORIGINAL_STEPS.ACADEMIC;
  } else {
    return ORIGINAL_STEPS.ACADEMIC;
  }
}

export function getStepFromType(state, id, blueprintId) {
  const job = runReducer.getJob(state, id);
  const setup = getSetup(state, id);

  if (id === "academic") {
    const dataset = setupReducer.getDatasetFromSetup(state, runId);
    return getPrebuiltSteps(
      id,
      dataset &&
        dataset.fields &&
        dataset.outcome &&
        dataset.fields[dataset.outcome] &&
        dataset.fields[dataset.outcome].type
    );
  }

  const isContinuous = getOutcomeType(state, id) === "number";

  const isAdvanced = getIsAdvancedCosts(state, setup && setup.blueprintId);

  if (isAdvanced) {
    return isContinuous ? ORIGINAL_STEPS.ADVANCED_CONTINUOUS : ORIGINAL_STEPS.ADVANCED_CATEGORICAL;
  } else if (job.runType === "5 Minute") {
    return isContinuous ? ORIGINAL_STEPS.AIBLE_CONTINUOUS : ORIGINAL_STEPS.AIBLE_CATEGORICAL;
  } else if (job.runType === "2 Minute") {
    return isContinuous ? ORIGINAL_STEPS.QUICK_CONTINUOUS : ORIGINAL_STEPS.QUICK_CATEGORICAL;
  } else if (job.runType === "Academic") {
    return ORIGINAL_STEPS.ACADEMIC;
  } else {
    return ORIGINAL_STEPS.ACADEMIC;
  }
}

export function getOutcomeTypeFromBlueprint(state, blueprintId) {
  const blueprint = getBlueprint(state, blueprintId);

  if (blueprintId === "new") {
    switch (wizardReducer.getModelType(state)) {
      case MODEL_TYPES.CLASSIFICATION:
        return "categorical";
      case MODEL_TYPES.REGRESSION:
        return "number";
      default:
        return;
    }
  }

  // Returns just the type if it's there
  return (
    blueprint &&
    blueprint.wizard &&
    blueprint.wizard.dataset &&
    blueprint.wizard.dataset.fields &&
    blueprint.wizard.dataset.outcome &&
    blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome] &&
    blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome].type
  );
}

export function getIndexFromLabel(state, blueprintId, label) {
  const blueprint = getBlueprint(state, blueprintId);

  return blueprint && blueprint.wizard && blueprint.wizard.steps ? blueprint.wizard.steps.indexOf(label) : 0;
}

export function getMarketplaceName(state, blueprintId) {
  return getBlueprint(state, blueprintId).marketplaceName || "";
}

export function getMarketplaceDescription(state, blueprintId) {
  return getBlueprint(state, blueprintId).marketplaceDescription || "";
}

export function getIgnoredFields(state, blueprintId) {
  const setup = getOriginalSetup(state, blueprintId);
  return setup ? setup.ignored : {};
}

export function getIsPrebuiltBlueprint(blueprintId) {
  return PREBUILT_BLUEPRINTS.includes(blueprintId);
}

/* Actions */
export function updateBlueprint(id, blueprint) {
  return { type: UPDATE_BLUEPRINT, id: id, data: blueprint };
}

export function resetBlueprints() {
  return { type: RESET_BLUEPRINTS };
}

export function updateBlueprints(blueprints) {
  return { type: UPDATE_BLUEPRINTS, data: blueprints };
}

export function updateCustomField(id, customField, nextId = undefined) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_CUSTOM_FIELD,
      id: id,
      data: customField,
      key: customField.id
    });

    if (nextId !== undefined) {
      const projectId = nextReducer.getProjectId(getState(), nextId);
      const project = projectReducer.getProject(getState(), projectId);

      project &&
        project.segments &&
        project.segments.forEach((segment) => {
          const runId = segment?.job?.job_id;

          let customValues = {
            ...setupReducer.getCustomValues(getState(), runId)
          };

          customValues[customField.id] = 0;

          dispatch(setupReducer.updateCustomValues(runId, customValues));
        });
    }

    return Promise.resolve();
  };
}

export function updateIsSensitive(id, column, isSensitive) {
  return {
    type: UPDATE_SENSITIVE,
    id: id,
    data: isSensitive,
    key: column
  };
}

export function updateCustomFieldById(id, cId, customField) {
  return {
    type: UPDATE_CUSTOM_FIELD,
    id: id,
    data: customField,
    key: cId
  };
}

export function deleteCustomField(id, cId) {
  return {
    type: DELETE_CUSTOM_FIELD,
    id: id,
    key: cId
  };
}

export function deleteCustomFieldById(id, runId, cId) {
  return (dispatch, getState) => {
    dispatch(deleteCustomField(id, cId));
    dispatch(setupReducer.validateCustomValues(runId, id));
  };
}

export function validateCustomFieldName(value) {
  // THIS DOES NOT USE DISPATCH
  if (!value && value !== 0) {
    return false;
  }
  return CUSTOM_FIELD_VALID_CHARS.test(value);
}

export function updateAdvancedInput(id, inputId, evaluator, runId = "new") {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_ADVANCED_INPUT,
      id: id,
      data: evaluator,
      key: inputId
    });

    dispatch(checkEvaluator(id, runId));
  };
}
export function updateIsAdvanced(id, isAdvanced) {
  return { type: UPDATE_FIELD, id: id, data: isAdvanced, key: "isAdvanced" };
}

export function updateDataRecipe(id, recipe) {
  return { type: UPDATE_FIELD, id: id, data: recipe, key: "recipe" };
}

export function updateImportRecipeId(id, recipeId) {
  return { type: UPDATE_FIELD, id: id, data: recipeId, key: "importRecipeId" };
}

export function updateDeployRecipeId(id, recipeId) {
  return { type: UPDATE_FIELD, id: id, data: recipeId, key: "deployRecipeId" };
}

export function updateIsLocked(id, isLocked) {
  return { type: UPDATE_FIELD, id: id, data: isLocked, key: "isLocked" };
}

export function updateAppStartViewType(id, appStartViewType) {
  return { type: UPDATE_FIELD, id: id, data: appStartViewType, key: "appStartViewType" };
}

export function updateIsEditing(id, isEditing) {
  return {
    type: UPDATE_BLUEPRINT_FIELD,
    id: id,
    data: isEditing,
    key: "isEditing"
  };
}

export function updateMarketplaceName(id, data) {
  return { type: UPDATE_BLUEPRINT_FIELD, id, data, key: "marketplaceName" };
}

export function updateMarketplaceDescription(id, data) {
  return {
    type: UPDATE_BLUEPRINT_FIELD,
    id,
    data,
    key: "marketplaceDescription"
  };
}

export function updateDataField(id, field) {
  return (dispatch, getState) => {
    const blueprint = { ...getBlueprint(getState(), id) };

    return dispatch({
      type: UPDATE_FIELD,
      id: id,
      key: "dataset",
      data:
        blueprint && blueprint.wizard && blueprint.wizard.dataset && blueprint.wizard.dataset.fields
          ? {
              ...blueprint.wizard.dataset,
              fields: {
                ...blueprint.wizard.dataset.fields,
                [field.label]: { ...field }
              }
            }
          : { fields: { [field.label]: { ...field } } }
    });
  };
}

export function deleteBlueprintField(id, key) {
  return { type: DELETE_BLUEPRINT_FIELD, id, key };
}

export function saveBlueprintToAPI(name, wizard, folderIdOverride) {
  return (dispatch, getState) => {
    const folderId = folderIdOverride ?? foldersReducer.getSelectedFolder(getState());
    return BlueprintAPI.createBlueprint(wizard, folderId, name).then((r) => {
      dispatch(updateBlueprint(r.id, r));
      return r;
    });
  };
}

export function resetMarketplaceDetails(id) {
  return (dispatch, getState) => {
    dispatch(deleteBlueprintField(id, "marketplaceName"));
    return dispatch(deleteBlueprintField(id, "marketplaceDescription"));
  };
}

function evaluateField(blueprintId, setupId, customValues, advancedInputs, field) {
  const parser = new Parser();

  let retValue;

  try {
    const expression = parser.parse(advancedInputs[field]);
    retValue = expression.evaluate(customValues);
  } catch (e) {
    retValue = "Error";
  }
  return retValue;
}

export function checkEvaluator(blueprintId, setupId, isBaseline = false, checkOtherRuns = true) {
  return (dispatch, getState) => {
    const state = getState();

    const projectId = projectReducer.getProjectIdFromRunId(state, setupId);

    if (checkOtherRuns && !isNaN(projectId)) {
      projectReducer.getAllJobIdsFromOptimizer(state, projectId, true)?.forEach((rId) => {
        if (rId !== setupId) {
          dispatch(checkEvaluator(blueprintId, rId, isBaseline, false));
        }
      });
    }

    let advancedInputs = {
      ...getAdvancedInputs(state, blueprintId),
      ...setupReducer.getAdvancedInputs(state, setupId)
    };

    const customValues = isBaseline
      ? {
          ...setupReducer.getCustomValues(state, setupId),
          ...setupReducer.getBaselineCustomValues(state, setupId)
        }
      : setupReducer.getCustomValues(state, setupId);

    let customFields = { ...getCustomFields(state, blueprintId) };
    const setupCFields = setupReducer.getCustomFields(state, setupId);
    if (setupCFields && Object.keys(setupCFields)?.length) {
      let hasAllValues = Object.keys(customValues).every(
        (k) => setupCFields[k] !== undefined || customFields[k] === undefined
      );
      if (hasAllValues) {
        customFields = { ...setupCFields };
      } else {
        customFields = {
          ...customFields,
          ...setupCFields
        };
      }
    }
    const chars = ["\\(", " ", "\\+", "\\*", "/", "-"];

    if (customValues === undefined) {
      return;
    }

    Object.keys(customValues).forEach((c) =>
      Object.keys(advancedInputs).forEach((k) => {
        if (advancedInputs[k]) {
          if (advancedInputs[k][0] !== " ") {
            advancedInputs[k] = " " + advancedInputs[k];
          }
          chars.forEach(
            (help) => (advancedInputs[k] = advancedInputs[k].replaceAll(help + c, help.replace("\\", "") + c))
          );
        }
      })
    );

    customFields &&
      Object.keys(customFields).forEach((c) => {
        if (customValues[c] === undefined) {
          customValues[c] = "0";
        }
      });

    if (customFields) {
      if (advancedInputs["advancedRevenue"]) {
        const advancedRevenue = evaluateField(blueprintId, setupId, customValues, advancedInputs, "advancedRevenue");

        if (isBaseline) {
          dispatch(setupReducer.updateBaselineAdvancedRevenue(setupId, advancedRevenue));
        } else {
          dispatch(setupReducer.updateAdvancedRevenue(setupId, advancedRevenue));
        }
      }

      if (advancedInputs["advancedCost"]) {
        const advancedCost = evaluateField(blueprintId, setupId, customValues, advancedInputs, "advancedCost");
        if (isBaseline) {
          dispatch(setupReducer.updateBaselineAdvancedCost(setupId, advancedCost));
        } else {
          dispatch(setupReducer.updateAdvancedCost(setupId, advancedCost));
        }
      }

      let shouldUpdate = false;
      let costs = {
        conversionGain: isBaseline
          ? setupReducer.getBaselineConversionGain(getState(), setupId)
          : setupReducer.getConversionGain(getState(), setupId),
        conversionCost: isBaseline
          ? setupReducer.getBaselineConversionCost(getState(), setupId)
          : setupReducer.getConversionCost(getState(), setupId),
        conversionMissed: isBaseline
          ? setupReducer.getBaselineConversionMissed(getState(), setupId)
          : setupReducer.getConversionMissed(getState(), setupId),
        conversionSaved: isBaseline
          ? setupReducer.getBaselineConversionSaved(getState(), setupId)
          : setupReducer.getConversionSaved(getState(), setupId)
      };

      let errorCosts = {};

      if (advancedInputs["truePositive"]) {
        const conversionGain = evaluateField(blueprintId, setupId, customValues, advancedInputs, "truePositive");

        if (isFinite(conversionGain)) {
          costs.conversionGain = conversionGain;
          shouldUpdate = true;
        }

        errorCosts.conversionGain = conversionGain;
      }

      if (advancedInputs["falsePositive"]) {
        const conversionCost = evaluateField(blueprintId, setupId, customValues, advancedInputs, "falsePositive");

        if (isFinite(conversionCost)) {
          costs.conversionCost = conversionCost;
          shouldUpdate = true;
        }

        errorCosts.conversionCost = conversionCost;
      }

      if (advancedInputs["trueNegative"]) {
        const conversionSaved = evaluateField(blueprintId, setupId, customValues, advancedInputs, "trueNegative");

        if (isFinite(conversionSaved)) {
          costs.conversionSaved = conversionSaved;
          shouldUpdate = true;
        }

        errorCosts.conversionSaved = conversionSaved;
      }

      if (advancedInputs["falseNegative"]) {
        const conversionMissed = evaluateField(blueprintId, setupId, customValues, advancedInputs, "falseNegative");

        if (isFinite(conversionMissed)) {
          costs.conversionMissed = conversionMissed;
          shouldUpdate = true;
        }

        errorCosts.conversionMissed = conversionMissed;
      }

      console.log(errorCosts);
      console.log(costs);

      dispatch(setupReducer.updateErrorCosts(setupId, errorCosts));

      if (shouldUpdate) {
        if (isBaseline) {
          dispatch(setupReducer.updateBaselineConversionGain(setupId, costs.conversionGain));
          dispatch(setupReducer.updateBaselineConversionCost(setupId, costs.conversionCost));
          dispatch(setupReducer.updateBaselineConversionMissed(setupId, costs.conversionMissed));
          dispatch(setupReducer.updateBaselineConversionSaved(setupId, costs.conversionSaved));
        } else {
          dispatch(setupReducer.updateCosts(setupId, costs));
        }
      }
    }

    if (checkOtherRuns && !isNaN(projectId)) {
      dispatch(projectReducer.resetBudget(projectId, false, true));
    }

    return Promise.resolve();
  };
}

export function deleteBlueprint(id) {
  return (dispatch, getState) => {
    let blueprints = { ...getGlobal(getState()) };

    delete blueprints[id];

    return dispatch(updateBlueprints(blueprints));
  };
}

export function updateDescription(id, bId, description) {
  return (dispatch, getState) => {
    const blueprint = dispatch(getExistsBlueprint(getState(), id));

    return dispatch({
      type: UPDATE_FIELD,
      id: id,
      data: description,
      key: bId
    });
  };
}

export function updateColumnDescription(id, column, description) {
  return (dispatch, getState) => {
    const blueprint = dispatch(getExistsBlueprint(getState(), id));

    return dispatch({
      type: UPDATE_FIELD,
      id: id,
      data: description,
      key: cDel + column
    });
  };
}

export function handleDelete(id) {
  return async (dispatch, getState) => {
    const blueprint = getBlueprint(getState(), id);

    const blueprints = getBlueprints(getState());

    if (blueprint?.wizard?.chatGPT?.chatType) {
      const childBlueprints = blueprints.filter((b) => {
        return b?.wizard?.chatGPT?.lineage?.find((lb) => {
          return lb?.id === id;
        });
      });

      if (childBlueprints?.length) {
        const isPlural = childBlueprints.length !== 1;
        let message = `Unable to delete. ${blueprint.name} is referenced by ${childBlueprints.length} child${isPlural ? "ren" : ""} agent template${isPlural ? "s" : ""}.`;
        childBlueprints.forEach((cBp) => {
          message += `\n- ${cBp?.name}`;
        });
        message += `\n${isPlural ? "These agent templates" : "This agent template"} must be deleted before ${blueprint.name} can be deleted.`;
        toast(message, {
          type: toast.TYPE.ERROR,
          position: toast.POSITION.TOP_CENTER,
          autoClose: 7500
        });
        return Promise.resolve();
      }
    }

    const azTests = blueprints.filter((b) => {
      if (b.wizard.isAZTestApp) {
        const azTests = b?.wizard?.azTests;
        const currTest = azTests[azTests.length - 1] ?? azTests[0];
        const azTestApps = currTest?.testApps;
        if (azTestApps?.length) {
          const isUsed = azTestApps?.some((aId) => {
            return Number(aId) === Number(id);
          });
          if (isUsed) {
            return true;
          }
        }
      }
      return false;
    });

    if (azTests?.length) {
      const isPlural = azTests.length !== 1;
      let message = `Unable to delete. ${blueprint.name} is used in ${azTests.length} A/Z Test${isPlural ? "s" : ""}.`;
      azTests.forEach((cBp) => {
        message += `\n- ${cBp?.name}`;
      });
      message += `\n${isPlural ? "These A/Z Tests" : "This A/Z Test"} must be deleted or completed before ${blueprint.name} can be deleted.`;
      toast(message, {
        type: toast.TYPE.ERROR,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      });
      return Promise.resolve();
    }

    const shouldDelete = confirm(
      "You are about to delete: " +
        (blueprint ? blueprint.name : id) +
        ". This will prevent you from updating any projects created from this item. " +
        "Are you sure you'd like to continue?"
    );

    if (shouldDelete) {
      await BlueprintAPI.handleDelete(id).then((response) => {
        dispatch(deleteBlueprint(id));

        const isAgentPinned = viewReducer.getIsAgentPinned(getState(), id);
        if (isAgentPinned) {
          dispatch(viewReducer.updateIsAgentPinned(id, false));
        }
      });

      dispatch(fetchNextBlueprints());
      return Promise.resolve(true);
    } else {
      return Promise.resolve(false);
    }
  };
}

export function createBlueprintFromBlueprint(
  blueprint,
  useCase = false,
  openAgentOnSave = false,
  saveToMyWork = false,
  isChatTemplate = false,
  forceToastMessage = undefined,
  skipToast = false
) {
  return (dispatch, getState) => {
    dispatch(updateIsBlueprintCreating(true));

    let folderId = foldersReducer.getSelectedFolder(getState());

    let toastMessage = "Item Sucessfully Imported";

    if (useCase) {
      toastMessage = "Agent Template Successfully Imported";
    }

    if (isChatTemplate) {
      toastMessage = "Template saved to your work";
    }

    const shouldSaveWork = isEnabled("chat-aible-templates") ? saveToMyWork : undefined;

    const retBlueprint = {
      ...blueprint,
      wizard: {
        ...blueprint?.wizard,
        isSavedWork: shouldSaveWork,
        template: blueprint?.wizard?.template
          ? {
              ...blueprint.wizard.template,
              wizard: {
                ...blueprint.wizard.template.wizard,
                isSavedWork: shouldSaveWork
              }
            }
          : undefined,
        aibleAnywhere: blueprint?.wizard?.aibleAnywhere
          ? {
              ...blueprint?.wizard?.aibleAnywhere,
              isSavedWork: shouldSaveWork
            }
          : undefined
      }
    };

    if (shouldSaveWork) {
      toastMessage = "Saved to my templates";
    }

    if (forceToastMessage !== undefined) {
      toastMessage = forceToastMessage;
    }

    // console.log("What is retBlueprint", retBlueprint);

    return BlueprintAPI.createBlueprint(retBlueprint.wizard, folderId, retBlueprint.name).then((response) => {
      if (!skipToast) {
        toast(toastMessage, {
          type: toast.TYPE.SUCCESS,
          position: toast.POSITION.TOP_CENTER,
          autoClose: 7500
        });
      }

      dispatch(updateIsBlueprintCreating(false));
      dispatch(updateBlueprint(response.id, response));

      dispatch(aibleAnywhereReducer.fetchAA());
      dispatch(templateReducer.fetchTemplates(true));

      if (openAgentOnSave && isEnabled("chat-aible-templates")) {
        dispatch(push("/templates/" + response?.id));
      }

      if (openAgentOnSave && retBlueprint?.wizard?.aibleAnywhere !== undefined) {
        // Updated aible agents to use agent/{id}/new or agent/{id}/template for 'template view'
        dispatch(push("/agent/" + response?.id + (retBlueprint?.wizard?.aibleAnywhere?.isAibleAgent ? "/new" : "")));
      }

      return response;

      // if (isChatTemplate) {
      //   dispatch(viewReducer.updateType(viewReducer.VIEW_TYPE.TEMPLATES));
      //   dispatch(push("/"));
      // }

      //return dispatch(push("/blueprint/" + response.id));
    });
  };
}

export function createBlueprintFromBlueprintId(options) {
  const { id, useCase, openAgentOnSave, saveToMyWork, isChatTemplate, forceToastMessage } = options;

  return (dispatch, getState) => {
    const blueprint = getBlueprint(getState(), id);
    dispatch(
      createBlueprintFromBlueprint(blueprint, useCase, openAgentOnSave, saveToMyWork, isChatTemplate, forceToastMessage)
    );
  };
}

export function createBlueprint(id, blueprintId, publishToMarketplace = false) {
  return (dispatch, getState) => {
    const state = getState();

    const rawBP = getBlueprint(state, blueprintId);
    const transform = transformReducer.getTransform(state, id);

    if (blueprintId !== "new" && blueprintId !== undefined) {
      updateIsEditing(blueprintId, false);
    }

    let blueprint = JSON.parse(JSON.stringify(rawBP && rawBP.wizard ? rawBP.wizard : rawBP));

    // Used to check for changes under "new" for blueprint
    // Removed because changes are no longer saved under "new"

    blueprint.setup = {
      ...getSetup(state, id),
      transform: { ...transform }
    };

    const dataset =
      rawBP && rawBP.wizard && rawBP.wizard.dataset ? rawBP.wizard.dataset : getDatasetFromSetup(state, id);

    if (dataset && dataset.fields) {
      let fields = {};

      Object.keys(dataset.fields)
        .filter((f) => blueprint && blueprint.setup && blueprint.setup.ignored && !blueprint.setup.ignored[f])
        .forEach(
          (f) =>
            (fields[f] = {
              label: f,
              type: dataset.fields[f].type,
              desc: getColumnDescription(state, id, f)
            })
        );

      blueprint.dataset = {
        ...dataset,
        rulefit: undefined,
        fields: fields
      };
    }

    if (rawBP && rawBP.isAible === true) {
      blueprint.steps = getSteps(state, id, blueprintId);
    }

    if (blueprint.marketplace) {
      blueprint.marketplace.created_by = undefined;
      blueprint.isMarketplace = undefined;
    }

    if (publishToMarketplace) {
      //Marketplace Demo
      if (publishToMarketplace === true) {
        blueprint.marketplace = {
          ...blueprint.marketplace,
          list: true,
          purchased: false,
          blueprintDetails: marketplaceDemoReducer.getNewBP(state)
        };
      } else {
        blueprint = {
          ...blueprint,
          ...publishToMarketplace
        };
        blueprint.setup
          ? (blueprint.setup.label = publishToMarketplace.marketplace.name)
          : (blueprint.setup = {
              label: publishToMarketplace.marketplace.name
            });
      }
    }

    dispatch(updateIsBlueprintCreating(true));

    let folderId = foldersReducer.getSelectedFolder(getState());

    return BlueprintAPI.createBlueprint(blueprint, folderId).then((response) => {
      let toastText = "Blueprint Sucessfully Created";
      if (publishToMarketplace) {
        toastText = "Blueprint Published to Marketplace";
      }

      toast(toastText, {
        type: toast.TYPE.SUCCESS,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      });

      dispatch(updateIsBlueprintCreating(false));

      // Marketplace Demo (!== true check only)
      if (publishToMarketplace && publishToMarketplace !== true) {
        dispatch(marketplaceReducer.updateBlueprint(response.id, response));
      } else {
        dispatch(updateBlueprint(response.id, response));
      }

      if (publishToMarketplace === false) {
        dispatch(push("/blueprint/" + response.id));
      }

      //dispatch(updateIsEditing(response.id, true));

      return Promise.resolve();
    });
  };
}

export function createAndLoadBlueprint(id) {
  return (dispatch, getState) => {
    return dispatch(createBlueprint(id)).then((response) => {
      dispatch(push("/blueprint/" + response.id));

      document.getElementById("wizardScroll") &&
        wizardScroll.scrollTo({
          top: wizardScroll.scrollHeight
        });
    });
  };
}

function filterMarketplaceDemo(blueprints, dispatch, getState) {
  const models = marketplaceDemoReducer.getBPModels(getState()) || {};
  const consulting = marketplaceDemoReducer.getBPConsulting(getState()) || {};
  const filteredBPs = blueprints.filter((bp) => {
    if (bp.wizard && bp.wizard.type) {
      switch (bp.wizard.type) {
        case MarketplaceDemoAPI.TYPES.model:
          if (bp.wizard.marketplace && bp.wizard.marketplace.modelDetails) {
            models[bp.wizard.marketplace.modelDetails.id] = bp;
          }
          break;
        case MarketplaceDemoAPI.TYPES.consulting:
          if (bp.wizard.marketplace && bp.wizard.marketplace.consultingDetails) {
            consulting[bp.id] = bp;
          }
        default:
      }
      return false;
    }
    return true;
  });
  dispatch(marketplaceDemoReducer.updateBPModels(models));
  dispatch(marketplaceDemoReducer.updateBPConsulting(consulting));
  return filteredBPs;
}

export function transformBlueprints(state, data) {
  let currentBlueprints = getGlobal(state);

  for (const blueprint of data) {
    currentBlueprints[blueprint.id] = { ...blueprint };
  }

  return currentBlueprints;
}

// Add aible blueprints into the reducer based on flag settings
export function fetchAibleBlueprints() {
  return (dispatch, getState) => {
    if (isEnabled("chat-aible") && isEnabled("dataset-whats-changed") && isEnabled("chat-aible-whats-changed")) {
      dispatch(updateBlueprint(CHATAIBLE_WHATS_CHANGED.id, CHATAIBLE_WHATS_CHANGED));
    }

    if (isEnabled("chat-aible") && isEnabled("chat-aible-benchmark")) {
      dispatch(updateBlueprint(CHATAIBLE_BENCHMARK.id, CHATAIBLE_BENCHMARK));
    }

    if (isEnabled("chat-aible") && isEnabled("chat-aible-sql-queries")) {
      dispatch(updateBlueprint(CHATAIBLE_SQL.id, CHATAIBLE_SQL));
    }

    if (isEnabled("chat-aible") && isEnabled("chat-aible-document-summarization")) {
      dispatch(updateBlueprint(CHATAIBLE_DOCUMENT_SUMMARIZATION.id, CHATAIBLE_DOCUMENT_SUMMARIZATION));
      dispatch(updateBlueprint(CHATAIBLE_DOCUMENT_SUMMARIZATION_SIMPLE.id, CHATAIBLE_DOCUMENT_SUMMARIZATION_SIMPLE));
    }

    if (isEnabled("chat-aible") && isEnabled("document-set-kpi-analysis")) {
      dispatch(updateBlueprint(CHATAIBLE_KPI_ANALYSIS.id, CHATAIBLE_KPI_ANALYSIS));
    }

    if (isEnabled("chat-aible") && isEnabled("chat-agent-iq")) {
      dispatch(updateBlueprint(CHATAIBLE_AGENT_IQ.id, CHATAIBLE_AGENT_IQ));
      dispatch(updateBlueprint(CHATAIBLE_AGENT_IQ_STREAM.id, CHATAIBLE_AGENT_IQ_STREAM));
      dispatch(updateBlueprint(CHATAIBLE_AGENT_IQ_TEAM.id, CHATAIBLE_AGENT_IQ_TEAM));
    }

    if (isEnabled("chat-reason")) {
      dispatch(updateBlueprint(CHATAIBLE_REASON.id, CHATAIBLE_REASON));
      dispatch(updateBlueprint(CHATAIBLE_REASON_NLQ.id, CHATAIBLE_REASON_NLQ));
    }

    if (isEnabled("chat-aible")) {
      dispatch(updateBlueprint(CHATAIBLE_OPTIMIZE.id, CHATAIBLE_OPTIMIZE));
      dispatch(updateBlueprint(CHATAIBLE_PREDICT.id, CHATAIBLE_PREDICT));
    }

    if (isEnabled("chat-aible-agent-c")) {
      dispatch(updateBlueprint(CHATAIBLE_AGENT_C.id, CHATAIBLE_AGENT_C));
    }

    if (isEnabled("aiq-deep-research-agent")) {
      dispatch(updateBlueprint(AIQ_DEEP_RESEARCH.id, AIQ_DEEP_RESEARCH));
    }

    if (isEnabled("openshell")) {
      dispatch(updateBlueprint(OPENSHELL.id, OPENSHELL));
    }

    if (isEnabled("claude-code-agent")) {
      dispatch(updateBlueprint(CLAUDE_CODE.id, CLAUDE_CODE));
    }
  };
}

export function getTemplateSampleBlueprints(skipCurrentDatasetUpdate = false) {
  return async (dispatch, getState) => {
    const sampleFolderId = foldersReducer.getAibleSampleDataFolderId(getState());

    if (sampleFolderId) {
      let sampleDatasets = await DatasetAPI.getDatasets({
        folderId: sampleFolderId,
        fetchAll: true
      });

      // Logic to ignore clobbering a loaded dataset on page refresh when this is triggered from fetchAll() in
      // accountsReducer if the dataset is loaded/has pivot tables.
      if (skipCurrentDatasetUpdate) {
        const nextId = nextReducer.getCurrentNextId(getState());
        const datasetId = nextReducer.getDatasetId(getState(), nextId);
        const hasLoadedDataset = homeReducer.getIsExploreReady(getState(), datasetId);
        const foundDatasetInSamples = sampleDatasets?.find((d) => d?.id === datasetId);
        if (hasLoadedDataset && foundDatasetInSamples) {
          sampleDatasets = sampleDatasets?.filter((d) => d?.id !== datasetId);
        }
      }

      dispatch(updateDatasets(homeReducer.transformDatasets(getState(), sampleDatasets)));
      await dispatch(languageModelArtifactReducer.fetchAllArtifacts(sampleFolderId, { type: "CORPUS" }));

      let usecaseTemplates = [];
      if (isEnabled("show-all-chat-templates")) {
        usecaseTemplates = [...ANALYTICS_USECASE_TEMPLATES];

        if (isEnabled("chat-aible") && isEnabled("chat-aible-sql-queries")) {
          usecaseTemplates.push(...NLQ_USECASE_TEMPLATES);
        }

        if (isEnabled("chat-aible") && isEnabled("chat-aible-document-summarization")) {
          usecaseTemplates.push(...DOCSUM_USECASE_TEMPLATES);
        }

        if (isEnabled("chat-aible") && isEnabled("chat-aible-optimize")) {
          usecaseTemplates.push(...AIBLE_OPTIMIZE_TEMPLATES);
        }
      }

      if (isEnabled("chat-aible") && isEnabled("dataset-whats-changed") && isEnabled("chat-aible-whats-changed")) {
        usecaseTemplates.push(...WHATS_CHANGED_USECASE_TEMPLATES);
      }

      if (isEnabled("chat-aible") && isEnabled("walmart-agents")) {
        usecaseTemplates.push(...WALMART_TEMPLATES);
      }

      usecaseTemplates.push(...BENCHMARK_SAMPLE_TEMPLATES);

      let retBlueprints = { ...getGlobal(getState()) };

      usecaseTemplates.forEach((template) => {
        const retTemplate = {
          ...template
        };

        const replaceDataset =
          retTemplate?.wizard?.templateSample && retTemplate?.wizard?.templateSampleType === "DATASET"
            ? retTemplate?.wizard?.templateSample
            : undefined;
        const replaceArtifact =
          retTemplate?.wizard?.templateSample && retTemplate?.wizard?.templateSampleType === "ARTIFACT"
            ? retTemplate?.wizard?.templateSample
            : undefined;

        if (replaceDataset || replaceArtifact) {
          if (replaceDataset) {
            const datasetString = TEMPLATES_SAMPLE_DATA?.[replaceDataset]?.nameMatch;
            const retSampleDataId = dispatch(getTemplateSampleDatasetIdByString(sampleFolderId, datasetString));

            retTemplate.wizard.datasetId = retSampleDataId;
            retTemplate.wizard.steps[0].datasetId = retSampleDataId;
            retTemplate.wizard.isSampleData = true;
          }

          if (replaceArtifact) {
            const artifactString = TEMPLATES_SAMPLE_DATA?.[replaceArtifact]?.nameMatch;
            const retSampleArtifactId = dispatch(getTemplateSampleArtifactIdByString(sampleFolderId, artifactString));

            retTemplate.wizard.artifactId = retSampleArtifactId;
            retTemplate.wizard.steps[0].artifactId = retSampleArtifactId;
            retTemplate.wizard.isSampleData = true;
          }
          retBlueprints = { ...retBlueprints, [template?.id]: retTemplate };
        }
      });
      // Using updateBlueprints for a single dispatch at the end instead of individual blueprint update dispatches.
      dispatch(updateBlueprints(retBlueprints));
    }

    return;
  };
}

export function fetchSampleBlueprints() {
  return (dispatch, getState) => {
    if (!isEnabled("chat-aible-optimize")) {
      return;
    }
    const retBlueprints = { ...getGlobal(getState()), ...SAMPLE_BLUEPRINTS };
    return dispatch(updateBlueprints(retBlueprints));
  };
}

export function getTemplateSampleDatasetIdByString(sampleFolderId, nameMatch) {
  return (dispatch, getState) => {
    const sampleFolderData = homeReducer
      .getDatasetsArr(getState())
      .filter((dataset) => dataset?.folder_id === sampleFolderId);
    const foundDataset = sampleFolderData.find((data) => data?.name === nameMatch);
    // if (!foundDataset) {
    //   console.log("Could not find sample dataset for: ", nameMatch);
    // }
    return foundDataset?.id;
  };
}

export function getTemplateSampleArtifactIdByString(sampleFolderId, nameMatch) {
  return (dispatch, getState) => {
    const sampleFolderArtifacts = languageModelArtifactReducer.getCorpusList(getState(), sampleFolderId);
    const foundArtifact = sampleFolderArtifacts.find(
      (corpus) => corpus?.name?.toLowerCase() === nameMatch?.toLowerCase()
    );
    return foundArtifact?.id;
  };
}

export function fetchNextBlueprints(skipCurrentDatasetUpdate = false) {
  return (dispatch, getState) => {
    dispatch(updateIsBlueprintsLoading(true));

    const activeBlueprintId = getActiveBlueprintId(getState());

    let userId = null;
    // if (getIsMarketplace()) {
    //   userId = loginReducer.getUserID();
    // }
    // let isPrivate = loginReducer.getIsSharingPrivate(getState());
    // if (isPrivate) {
    //   userId = loginReducer.getUserID();
    // }

    let state = getState();
    const folderId = foldersReducer.getSelectedFolder(state);

    return BlueprintAPI.getBlueprints(folderId).then((data) => {
      // MarketplaceDemo

      if (folderId !== foldersReducer.getSelectedFolder(getState())) {
        return;
      }
      data = filterMarketplaceDemo(data, dispatch, getState);

      const rawBlueprints = transformBlueprints(getState(), data);
      const { blueprints, marketplaceBps } = marketplaceReducer.filterBlueprints(rawBlueprints, getState());
      dispatch(marketplaceReducer.updateBlueprints(marketplaceBps));
      dispatch(updateBlueprints(blueprints));

      dispatch(fetchAibleBlueprints());

      console.log("fetchNextBlueprints");

      // MarketplaceDemo
      if (getIsMarketplaceDemo()) {
        dispatch(marketplaceDemoReducer.fetchData());
        dispatch(marketplaceDemoReducer.fetchBlueprints());
        dispatch(marketplaceDemoReducer.fetchModels());
        dispatch(marketplaceDemoReducer.fetchConsulting());
      }

      dispatch(fetchSampleBlueprints());

      Object.keys(blueprints).forEach((b) => {
        const blueprint = blueprints[b];

        if (blueprint.id === Number(activeBlueprintId)) {
          dispatch(wizardReducer.scrollToEnd(100));
        }
      });

      dispatch(aibleAnywhereReducer.fetchAA(true));
      dispatch(templateReducer.fetchTemplates(true));
      return dispatch(getTemplateSampleBlueprints(skipCurrentDatasetUpdate)).then(() => {
        return dispatch(updateIsBlueprintsLoading(false));
      });
    });
  };
}

export function lockBlueprint(id, isLocked) {
  return (dispatch, getState) => {
    dispatch(updateIsLocked(id, isLocked));

    const blueprint = getBlueprint(getState(), id).wizard;

    dispatch(updateIsBlueprintCreating(true));

    return BlueprintAPI.updateBlueprint(id, blueprint).then((response) => {
      toast("Blueprint Sucessfully " + (isLocked ? "Locked!" : "Unlocked!"), {
        type: toast.TYPE.SUCCESS,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      });

      dispatch(updateBlueprint(response.id, response));

      return dispatch(updateIsBlueprintCreating(false));
    });
  };
}

export function saveOpenShellBlueprint(bpConfig) {
  return (dispatch, getState) => {
    console.log("saveOpenShellBlueprint", bpConfig);

    const nBlueprint = {
      openshellConfig: bpConfig
    };

    const folderId = foldersReducer.getSelectedFolder(getState());

    return BlueprintAPI.createBlueprint(nBlueprint, folderId, bpConfig?.name ?? "OpenShell Template").then(
      (response) => {
        toast("Blueprint Sucessfully Created!", {
          type: toast.TYPE.SUCCESS,
          position: toast.POSITION.TOP_CENTER,
          autoClose: 7500
        });

        dispatch(updateBlueprint(response.id, response));

        dispatch(updateIsBlueprintCreating(false));

        return response.id;
      }
    );
  };
}

export function saveBlueprint(
  id,
  label,
  forceSetup = undefined,
  runId = undefined,
  createNew = false,
  nextObj = undefined,
  isUpdateBlueprint = false,
  forceCustomValues,
  hideToast = false
) {
  return (dispatch, getState) => {
    console.log("save blueprint id label isUpdateBlueprint", id, label, isUpdateBlueprint);

    const state = getState();

    var currData = (getBlueprint(state, id) || {}).wizard;
    if (!currData) {
      currData = {
        customFields: {},
        sensitive: {},
        advancedInputs: {
          truePositive: undefined,
          falsePositive: undefined,
          trueNegative: undefined,
          falseNegative: undefined
        },
        setup: {}
      };
    }

    let updateData = JSON.parse(JSON.stringify(currData));
    let folderId = foldersReducer.getSelectedFolder(getState());

    if (label !== undefined) {
      updateData = {
        ...updateData,
        setup: {
          ...updateData.setup,
          label: label
        }
      };
    }

    if (nextObj !== undefined) {
      updateData.nextObj = { ...nextObj };
    }

    if (forceSetup !== undefined) {
      updateData.setup = { ...forceSetup };
      updateData.description = forceSetup.description;
      if (forceSetup.advancedInputs) {
        updateData.advancedInputs = forceSetup.advancedInputs;
      }
      if (forceSetup.customFields) {
        updateData.customFields = forceSetup.customFields;
      }
    }

    if (setupReducer.getHasCustomMappings(getState(), runId, updateData?.setup)) {
      if (updateData.advancedInputs.truePositive === undefined) {
        updateData.advancedInputs.truePositive = String(updateData?.setup?.conversionGain);
      }
      if (updateData.advancedInputs.falsePositive === undefined) {
        updateData.advancedInputs.falsePositive = String(updateData?.setup?.conversionCost);
      }
    }

    if (forceCustomValues !== undefined) {
      updateData.setup.customValues = { ...forceCustomValues };
    }

    let dataset = updateData && updateData.dataset;

    if (forceSetup && forceSetup.datasetId) {
      dataset = getDataset(state, forceSetup.datasetId);
    } else if (setupReducer.getDatasetId(state, runId) !== undefined) {
      const datasetId = setupReducer.getDatasetId(state, runId);
      dataset = getDataset(state, runId);
    }

    if (dataset && dataset.fields) {
      let fields = {};

      Object.keys(dataset.fields)
        .filter((f) => updateData && updateData.setup && updateData.setup.ignored && !updateData.setup.ignored[f])
        .forEach((f) => {
          const retField = {
            label: f,
            type: dataset.fields[f].type,
            desc: getColumnDescription(state, id, f)
          };

          if (f === dataset?.target) {
            retField.leakage_info = dataset.fields[f].leakage_info;
          }

          fields[f] = retField;
        });

      const cleanDataset = {
        ...dataset,
        mappings: undefined,
        metadata: undefined,
        originalDataset: undefined,
        rulefit: undefined,
        fields: fields,
        ranked_fields: undefined,
        suggested_features: undefined,
        suggested_features_count: undefined
      };

      updateData.dataset = {
        ...cleanDataset
      };
    }

    dispatch(updateIsBlueprintCreating(true));

    // Centralizing Cleanup Logic
    const cleanupBlueprintSave = (response, message) => {
      toast(message, {
        type: toast.TYPE.SUCCESS,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      });

      dispatch(updateBlueprint(response.id, response));

      dispatch(updateIsBlueprintCreating(false));

      return response.id;
    };

    // We want to create a new blueprint every time
    return isUpdateBlueprint !== true
      ? BlueprintAPI.createBlueprint(updateData, folderId, label).then((response) => {
          if (hideToast !== true) {
            toast("Blueprint Sucessfully Created!", {
              type: toast.TYPE.SUCCESS,
              position: toast.POSITION.TOP_CENTER,
              autoClose: 7500
            });
          }

          dispatch(updateBlueprint(response.id, response));

          dispatch(updateIsBlueprintCreating(false));

          return response.id;
        })
      : BlueprintAPI.updateBlueprint(id, updateData, label).then((response) => {
          if (hideToast !== true) {
            toast("Blueprint Sucessfully Saved!", {
              type: toast.TYPE.SUCCESS,
              position: toast.POSITION.TOP_CENTER,
              autoClose: 7500
            });
          }

          dispatch(updateBlueprint(response.id, response));

          dispatch(updateIsBlueprintCreating(false));

          return response.id;
        });
  };
}

export function saveCurrentBlueprint(id) {
  return (dispatch, getState) => {
    const state = getState();

    var currData = getBlueprint(state, id).wizard;

    let updateData = JSON.parse(JSON.stringify(currData));
    updateData.setup = getSetup(state, "new");

    dispatch(updateIsBlueprintCreating(true));

    return BlueprintAPI.updateBlueprint(id, updateData).then((response) => {
      toast("Blueprint Sucessfully Saved!", {
        type: toast.TYPE.SUCCESS,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      });

      dispatch(updateBlueprint(response.id, response));

      return dispatch(updateIsBlueprintCreating(false));
    });
  };
}

export function openTemplateBlueprint(aibleMode, isSaveDataset = false) {
  return (dispatch, getState) => {
    const dataset = getDatasetFromSetup(getState(), "new");

    let type = "template";
    if (aibleMode === wizardReducer.AIBLE_MODES.ACADEMIC) {
      type = "academic";
    }

    dispatch(resetSetup("new"));

    if (isSaveDataset && dataset && dataset.id) {
      dispatch(updateDatasetId("new", dataset.id));
    }

    dispatch(resetBlueprint(type));

    dispatch(openBlueprint(type));

    if (aibleMode === wizardReducer.AIBLE_MODES.ACADEMIC) {
      dispatch(setupReducer.generateNameAndUpdate("new", null));
    }

    return dispatch(wizardReducer.updateAibleMode("new", type, aibleMode));
  };
}

export function openBlueprint(id) {
  return (dispatch, getState) => {
    dispatch(handleOpenBlueprint(id));
  };
}

export function handleOpenBlueprint(blueprintId, datasetId, isChatStyle) {
  return (dispatch, getState) => {
    //updateBlueprint("new", {});
    //updateStep(0);

    dispatch(wizardReducer.updateStepIndex(0));
    dispatch(updateDatasetId("new", datasetId, true));
    dispatch(updateBlueprintId("new", blueprintId));

    if (isEnabled("edg")) {
      return dispatch(push("/eBlueprint/" + blueprintId));
    } else {
      const queryParams = [];
      if (blueprintId) {
        queryParams.push("blueprint=" + blueprintId);
      }
      if (datasetId) {
        queryParams.push("dataset=" + datasetId);
      }
      if (isChatStyle) {
        queryParams.push("isChatStyle=true");
      }

      if (isEnabled("aible-business-simple")) {
        return dispatch(push("/business/new" + constructQueryParams(queryParams)));
      }

      return dispatch(push("/project/new" + constructQueryParams(queryParams)));
    }
  };
}

export function initSetup(id, runId, currentSettings = {}) {
  return (dispatch, getState) => {
    const blueprint = getBlueprint(getState(), id);

    if (blueprint && blueprint.wizard && blueprint.wizard.setup) {
      const success =
        blueprint.wizard.setup.success && runId === "editBlueprint" ? blueprint.wizard.setup.success : undefined;
      const retSetup = _.merge({}, defaultSetup, blueprint.wizard.setup, currentSettings, {
        blueprintId: id,
        success: success
      });

      dispatch(updateSetup(runId, retSetup));
    } else {
      const retSetup = setupReducer.getSetup(getState(), "new");

      dispatch(updateSetup(runId, { ...retSetup }));
    }
  };
}

export function initBlueprint(id, runId) {
  return (dispatch, getState) => {
    console.log("initBlueprint id runId", id, runId);

    const state = getState();
    const blueprint = getBlueprint(state, id);

    if (blueprint && blueprint.folder_id) {
      const selectedFolder = foldersReducer.getSelectedFolder(getState());
      if (selectedFolder !== blueprint.folder_id) {
        dispatch(foldersReducer.updateSelectedFolder(blueprint.folder_id));
      }
    }

    if (getIsEditing(state, id) === true) {
      dispatch(updateIsEditing(id, false));
    }

    if (blueprint && blueprint.isAible === true) {
      const matchingTemplates = oldSteps.filter((o) => o.id === blueprint.id);

      if (matchingTemplates.length > 0) {
        dispatch(updateBlueprint(matchingTemplates[0].id, matchingTemplates[0]));
      }
    }

    if (blueprint && blueprint.wizard) {
      const dataset = blueprint.wizard.dataset;

      if (dataset !== undefined && dataset.id !== undefined && getDataset(state, dataset.id) === undefined) {
        dispatch(updateDataset(dataset.id, { ...dataset, isHidden: true }));
      }

      const oldSetup = getSetup(state, "new");

      const isCreateProject = globalReducer.getCreateFromProject(state);

      if (blueprint.wizard.setup && Object.keys(blueprint.wizard.setup).length > 2) {
        dispatch(
          updateSetup("new", {
            ...blueprint.wizard.setup,
            label: isCreateProject ? oldSetup.label : blueprint.wizard.setup.label,
            datasetId: oldSetup.datasetId,
            blueprintId: id,
            success: undefined
          })
        );
      } else {
        dispatch(
          updateSetup("new", {
            ...defaultSetup,
            datasetId: oldSetup.datasetId,
            success: undefined
          })
        );
      }
    }

    if (id) {
      const dataset = getDatasetFromSetup(getState(), runId);
      switch (id) {
        case "academic":
          dispatch(wizardReducer.updateAibleMode(runId, id, wizardReducer.AIBLE_MODES.ACADEMIC));
          dispatch(setupReducer.generateNameAndUpdate("new", dataset && dataset.id));
          break;
        case "template":
          if (dataset === undefined) {
            dispatch(wizardReducer.updateAibleMode(runId, id, wizardReducer.AIBLE_MODES.AIBLE));
            dispatch(setupReducer.generateNameAndUpdate("new", dataset && dataset.id));
          }
          break;
        default:
      }
    }

    return Promise.resolve();
  };
}

export function resetBlueprint(id) {
  return (dispatch, getState) => {
    dispatch(
      updateBlueprint(id, {
        id: id,
        wizard: {
          customFields: {},
          sensitive: {},
          advancedInputs: {
            truePositive: undefined,
            falsePositive: undefined,
            trueNegative: undefined,
            falseNegative: undefined
          }
        }
      })
    );
  };
}

export function reloadBlueprint(id) {
  return (dispatch, getState) => {
    const isAible = getIsAibleBlueprint(getState(), id);

    if (id !== "new" && isAible !== true) {
      dispatch(fetchBlueprint(id));
    }

    dispatch(
      updateBlueprint("new", {
        id: "new",
        wizard: {
          customFields: {},
          sensitive: {},
          advancedInputs: {
            truePositive: undefined,
            falsePositive: undefined,
            trueNegative: undefined,
            falseNegative: undefined
          }
        }
      })
    );

    //dispatch(updateStep(0));
    //dispatch(resetSetup("new"));

    // return dispatch(push("/blueprint/" + id));
  };
}

/*
import mockBp from "./mock_blueprint.json";

export function mockBlueprint() {
  return (dispatch, getState) => {
    let folderId = foldersReducer.getSelectedFolder(getState());

    return BlueprintAPI.createBlueprint(mockBp?.wizard, folderId, mockBp?.name);
  };
}
*/

export function fetchBlueprint(id) {
  return (dispatch, getState) => {
    if (id === "academic" || id === "new" || id === "newBlueprint") {
      return Promise.resolve();
    }

    return BlueprintAPI.getBlueprint(id).then((response) => dispatch(updateBlueprint(id, response)));
  };
}

export function addStep(id, blueprintId, step) {
  return (dispatch, getState) => {
    const stepList = getSteps(getState(), id, blueprintId);
    const modelType = wizardReducer.getModelType(getState(), id, blueprintId);

    const masterList = wizardReducer.getStepDefaultOrder([...stepList, step], modelType);

    const index = masterList.indexOf(step);

    const steps = stepList ? [...stepList.slice(0, index), step, ...stepList.slice(index)] : [step];

    dispatch(updateSteps(blueprintId, steps));

    return dispatch(wizardReducer.scrollToStepById(id, blueprintId, step));
  };
}

export function removeStep(id, blueprintId, index) {
  return (dispatch, getState) => {
    const steps = [
      ...getSteps(getState(), id, blueprintId).slice(0, index),
      ...getSteps(getState(), id, blueprintId).slice(index + 1)
    ];

    return dispatch(updateSteps(blueprintId, steps));
  };
}

export function increasePriority(id, blueprintId, index) {
  return (dispatch, getState) => {
    let retSteps = [...getSteps(getState(), id, blueprintId)];
    [retSteps[index - 1], retSteps[index]] = [retSteps[index], retSteps[index - 1]];

    return dispatch(updateSteps(blueprintId, retSteps));
  };
}

export function decreasePriority(id, blueprintId, index) {
  return (dispatch, getState) => {
    let retSteps = [...getSteps(getState(), id, blueprintId)];
    [retSteps[index + 1], retSteps[index]] = [retSteps[index], retSteps[index + 1]];

    return dispatch(updateSteps(blueprintId, retSteps));
  };
}

export function removeStepById(id, blueprintId, stepId) {
  return (dispatch, getState) => {
    const steps = [...getSteps(getState(), id, blueprintId).filter((s) => s !== stepId)];

    return dispatch(updateSteps(blueprintId, steps));
  };
}

export function updateOption(blueprintId, type, option, value) {
  return (dispatch, getState) => {
    const options = {
      ...getOptions(getState(), blueprintId),
      [type]: {
        ...getOptions(getState(), blueprintId)[type],
        [option]: value
      }
    };

    return dispatch({
      type: UPDATE_FIELD,
      id: blueprintId,
      data: options,
      key: "options"
    });
  };
}

export function updateSteps(id, steps) {
  return { type: UPDATE_FIELD, id: id, data: steps, key: "steps" };
}

export function setBlueprint(runId, id, keepLabels = false, keepValues = false, skipOverallChildren = false) {
  return (dispatch, getState) => {
    const state = getState();
    const blueprint = getBlueprint(state, id);

    const projectId = projectReducer.getProjectIdFromRunId(getState(), runId);
    const project = projectReducer.getProject(getState(), projectId);

    if (
      project?.segments &&
      project?.segments.length > 1 &&
      runId === project?.segments?.[0]?.job?.job_id &&
      skipOverallChildren === false
    ) {
      console.log("nonwonow");
      project?.segments
        .filter((segment) => segment?.job?.job_id !== project?.segments?.[0]?.job?.job_id)
        .forEach((segment) => {
          return dispatch(setBlueprint(segment?.job?.job_id, id, keepLabels, keepValues));
        });
    }

    if (blueprint && blueprint.folder_id) {
      const selectedFolder = foldersReducer.getSelectedFolder(getState());
      if (selectedFolder !== blueprint.folder_id) {
        dispatch(foldersReducer.updateSelectedFolder(blueprint.folder_id));
      }
    }

    if (getIsEditing(state, id) === true) {
      dispatch(updateIsEditing(id, false));
    }

    if (blueprint && blueprint.isAible === true) {
      const matchingTemplates = oldSteps.filter((o) => o.id === blueprint.id);

      if (matchingTemplates.length > 0) {
        dispatch(updateBlueprint(matchingTemplates[0].id, matchingTemplates[0]));
      }
    }

    if (blueprint && blueprint.wizard) {
      const dataset = blueprint.wizard.dataset;

      if (dataset !== undefined && dataset.id !== undefined && getDataset(state, dataset.id) === undefined) {
        dispatch(updateDataset(dataset.id, { ...dataset, isHidden: true }));
      }

      const oldSetup = getSetup(state, runId);

      let labelsToKeep = {};
      if (keepLabels) {
        labelsToKeep = setupReducer.getDefaultLabels(oldSetup);
      }

      let valuesToKeep = {};
      if (keepValues) {
        const VALUE_KEYS = [
          "customValues",
          "baselineCustomValues",
          "customMappings",
          "advancedInput",
          "errorCosts",
          "advancedCost",
          "advancedRevenue",
          "baselineAdvancedCost",
          "baselineAdvancedRevenue",
          "conversionCost",
          "conversionGain",
          "conversionMissed",
          "conversionSaved",
          "baselineConversionCost",
          "baselineConversionGain",
          "baselineConversionMissed",
          "baselineConversionSaved",
          "conversionRate",
          "pursuedRatio",
          "notPursuedRatio",
          "truePositive",
          "falsePositive",
          "trueNegative",
          "falseNegative"
        ];
        VALUE_KEYS.forEach((vKey) => {
          const oldValue = oldSetup[vKey];
          if (oldValue !== undefined) {
            valuesToKeep[vKey] = typeof oldValue === "object" ? JSON.parse(JSON.stringify(oldValue)) : oldValue;
          }
        });
      }

      const isCreateProject = globalReducer.getCreateFromProject(state);

      const sDataset = setupReducer.getDatasetFromSetup(state, runId);

      if (blueprint.wizard.setup && Object.keys(blueprint.wizard.setup).length > 2) {
        // quick hack, create new success object from sDataset to get correct counts
        const success =
          blueprint.wizard.setup.success &&
          blueprint.wizard.setup.success.value &&
          sDataset &&
          sDataset.fields &&
          sDataset.outcome &&
          sDataset.fields[sDataset.outcome] &&
          sDataset.fields[sDataset.outcome].data &&
          sDataset.fields[sDataset.outcome].data.filter((d) => d.value === blueprint.wizard.setup.success.value)
            .length > 0
            ? blueprint.wizard.setup.success
            : undefined;

        // Remove Forecast options if invalid
        const forecast = {
          forecastTimeCol: undefined,
          isForecast: false
        };

        if (
          blueprint.wizard.setup.forecastTimeCol &&
          sDataset &&
          homeReducer
            .getForecastOptions(state, sDataset.id, sDataset)
            .some((o) => o.value === blueprint.wizard.setup.forecastTimeCol)
        ) {
          forecast.forecastTimeCol = blueprint.wizard.setup.forecastTimeCol;
        }
        if (
          blueprint.wizard.setup.isForecast &&
          sDataset &&
          homeReducer.getIsForecastReady(state, sDataset.id, sDataset)
        ) {
          forecast.isForecast = blueprint.wizard.setup.isForecast;
        }

        const ignored = setupReducer.getNewDatasetIgnoredFromBp(getState(), sDataset && sDataset.id, id);

        let splitColumn = blueprint.wizard.setup.splitColumn;
        if (splitColumn && !sDataset?.fields?.[splitColumn]) {
          let transformedSplitColumn = sanitizeAliasForBQ(splitColumn);
          if (sDataset?.fields?.[transformedSplitColumn]) {
            splitColumn = transformedSplitColumn;
          } else {
            transformedSplitColumn = splitColumn?.replace(/_/g, " ");
            if (sDataset?.fields?.[transformedSplitColumn]) {
              splitColumn = transformedSplitColumn;
            }
          }
        }

        const retSetup = _.merge(
          {},
          {
            ...blueprint.wizard.setup,
            label: isCreateProject ? oldSetup.label : blueprint.wizard.setup.label,
            datasetId: oldSetup.datasetId,
            blueprintId: id,
            success: success,
            ...forecast,
            ...labelsToKeep,
            ignored: ignored,
            splitColumn: splitColumn,
            advancedInputs: {
              ...(blueprint.wizard.advancedInputs || {}),
              ...(blueprint.wizard.setup.advancedInputs || {})
            },
            customFields: {
              ...(blueprint.wizard.customFields || {}),
              ...(blueprint.wizard.setup.customFields || {})
            }
          },
          valuesToKeep
        );

        dispatch(updateSetup(runId, retSetup));
      } else {
        // Remove Forecast options if invalid
        const forecast = {
          forecastTimeCol: undefined,
          isForecast: false
        };

        if (
          oldSetup.forecastTimeCol &&
          sDataset &&
          homeReducer.getForecastOptions(state, sDataset.id, sDataset).some((o) => o.value === oldSetup.forecastTimeCol)
        ) {
          forecast.forecastTimeCol = oldSetup.forecastTimeCol;
        }
        if (oldSetup.isForecast && sDataset && homeReducer.getIsForecastReady(state, sDataset.id, sDataset)) {
          forecast.isForecast = oldSetup.isForecast;
        }
        const retSetup = _.merge(
          {},
          {
            ...defaultSetup,
            datasetId: oldSetup.datasetId,
            success: oldSetup.success,
            ...forecast,
            ...labelsToKeep
          },
          valuesToKeep
        );
        dispatch(updateSetup(runId, retSetup));
        if (runId === "new" && isFinite(oldSetup.datasetId)) {
          dispatch(setupReducer.updateDatasetId(runId, oldSetup.datasetId, true));
        }
      }
    }

    return Promise.resolve();
  };
}

export function setBlueprintOld(id, blueprintId) {
  return (dispatch, getState) => {
    dispatch(updateActiveBlueprintId(blueprintId));

    //dispatch(globalReducer.updateBlueprintId(blueprintId));
    //dispatch(globalReducer.updateRunId(id));

    if (!getIsPrebuiltBlueprint(blueprintId)) {
      dispatch(wizardReducer.init());
    } else {
      if (id === "new") {
        dispatch(wizardReducer.updateModelType(undefined));
      }
    }

    // TODO: Fix this gross ass fix for runs not loading before the rest of this executes;

    dispatch(wizardReducer.initStepIndex(id, blueprintId));

    if (blueprintId === "new" || blueprintId === "academic") {
      dispatch(
        updateBlueprint("new", {
          id: "new",
          wizard: {
            customFields: {},
            sensitive: {},
            advancedInputs: {
              truePositive: undefined,
              falsePositive: undefined,
              trueNegative: undefined,
              falseNegative: undefined
            }
          }
        })
      );
      const state = getState();
      const oSetup = getSetup(state, id);

      const isCreateFromProject = globalReducer.getCreateFromProject(state);
      const setupLabel = isCreateFromProject ? getSetupLabel(state, id) : "";

      dispatch(
        updateSetup(id, {
          ...defaultSetup,
          datasetId: oSetup.datasetId,
          label: setupLabel
        })
      );
      dispatch(updateIsBlueprint("new", true));
      if (blueprintId === "academic") {
        const dataset = getDatasetFromSetup(getState(), id);
        dispatch(wizardReducer.updateAibleMode(id, blueprintId, wizardReducer.AIBLE_MODES.ACADEMIC));
        if (!isCreateFromProject) {
          dispatch(setupReducer.generateNameAndUpdate("new", dataset && dataset.id));
        }
        if (
          dataset &&
          dataset.outcome &&
          dataset.fields &&
          dataset.fields[dataset.outcome] &&
          dataset.fields[dataset.outcome].type === "number"
        ) {
          if (setupReducer.getTruePositiveLabel(getState(), id) === defaultSetup.truePositiveLabel) {
            dispatch(setupReducer.updateTruePositiveLabel(id, "Overestimate"));
          }
          if (setupReducer.getFalsePositiveLabel(getState(), id) === defaultSetup.falsePositiveLabel) {
            dispatch(setupReducer.updateFalsePositiveLabel(id, "Underestimate"));
          }
        }
      }
    } else {
      const blueprint = getBlueprint(getState(), blueprintId);
      if (
        blueprint === undefined &&
        !getIsPrebuiltBlueprint(blueprintId) &&
        blueprintId !== "new" &&
        blueprintId !== "newBlueprint" &&
        blueprintId !== undefined
      ) {
        return BlueprintAPI.getBlueprint(blueprintId).then((response) => {
          dispatch(updateBlueprint(blueprintId, response));
          return dispatch(initBlueprint(blueprintId, id));
        });
      } else {
        dispatch(initBlueprint(blueprintId, id));
      }
    }

    return Promise.resolve();
  };
}

export function init(id, blueprintId) {
  return (dispatch, getState) => {
    dispatch(updateActiveBlueprintId(blueprintId));

    //dispatch(globalReducer.updateBlueprintId(blueprintId));
    //dispatch(globalReducer.updateRunId(id));

    if (!getIsPrebuiltBlueprint(blueprintId)) {
      dispatch(wizardReducer.init());
    } else {
      if (id === "new") {
        dispatch(wizardReducer.updateModelType(undefined));
      }
    }

    // TODO: Fix this gross ass fix for runs not loading before the rest of this executes;
    return (() => {
      if (id !== undefined && id !== "new") {
        return dispatch(runReducer.initRun(id));
      } else {
        return Promise.resolve();
      }
    })().then(() => {
      dispatch(wizardReducer.initStepIndex(id, blueprintId));

      if (blueprintId === "new" || blueprintId === "academic" || blueprintId === "editBlueprint") {
        dispatch(
          updateBlueprint("new", {
            id: "new",
            wizard: {
              customFields: {},
              sensitive: {},
              advancedInputs: {
                truePositive: undefined,
                falsePositive: undefined,
                trueNegative: undefined,
                falseNegative: undefined
              }
            }
          })
        );
        const state = getState();
        const oSetup = getSetup(state, id);

        const isCreateFromProject = globalReducer.getCreateFromProject(state);
        const setupLabel = isCreateFromProject ? getSetupLabel(state, "new") : "";

        if (id === "new") {
          dispatch(
            updateSetup("new", {
              ...defaultSetup,
              datasetId: oSetup.datasetId,
              label: setupLabel
            })
          );
          dispatch(runReducer.initWithJobID("new"));
        }
        dispatch(updateIsBlueprint("new", true));
        if (blueprintId === "academic") {
          const dataset = getDatasetFromSetup(getState(), id);
          dispatch(wizardReducer.updateAibleMode(id, blueprintId, wizardReducer.AIBLE_MODES.ACADEMIC));
          if (!isCreateFromProject) {
            dispatch(setupReducer.generateNameAndUpdate("new", dataset && dataset.id));
          }
          if (
            dataset &&
            dataset.outcome &&
            dataset.fields &&
            dataset.fields[dataset.outcome] &&
            dataset.fields[dataset.outcome].type === "number"
          ) {
            if (setupReducer.getTruePositiveLabel(getState(), id) === defaultSetup.truePositiveLabel) {
              dispatch(setupReducer.updateTruePositiveLabel(id, "Overestimate"));
            }
            if (setupReducer.getFalsePositiveLabel(getState(), id) === defaultSetup.falsePositiveLabel) {
              dispatch(setupReducer.updateFalsePositiveLabel(id, "Underestimate"));
            }
            if (setupReducer.getConversionCost(getState(), id) === defaultSetup.conversionCost) {
              dispatch(setupReducer.updateConversionCost(id, 1));
            }
            if (setupReducer.getConversionGain(getState(), id) === defaultSetup.conversionGain) {
              dispatch(setupReducer.updateConversionGain(id, 1));
            }
          }
        }
        return Promise.resolve();
      } else {
        const blueprint = getBlueprint(getState(), blueprintId);
        if (
          blueprint === undefined &&
          !getIsPrebuiltBlueprint(blueprintId) &&
          blueprintId !== "new" &&
          blueprintId !== "newBlueprint" &&
          blueprintId !== undefined
        ) {
          return BlueprintAPI.getBlueprint(blueprintId).then((response) => {
            dispatch(updateBlueprint(blueprintId, response));
            return dispatch(initBlueprint(blueprintId, id));
          });
        } else {
          return dispatch(initBlueprint(blueprintId, id));
        }
      }
    });

    return Promise.resolve();
  };
}

export default blueprintReducer;
